<!--
 * @Description: 档案审批
 * @Author: ma.cq
 * @Date: 2019-11-08 16:37:43
 * @LastEditors: Tina
 * @LastEditTime: 2023-01-06 15:36:35
 -->
<template>
  <el-dialog
    title="查看"
    :visible.sync="show"
    width="850px"
    @close="handleClose">
    <info-form :info="info"/>
    <span slot="footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import InfoForm from './components/infoForm'

export default {
  name: 'CheckDialog',
  components: { InfoForm },
  props: ['show', 'info'],
  methods: {
    handleClose () {
      this.$emit('update:show', false)
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
